// Public contact details shown across the site. bookings@ is forwarded to the
// owner's Gmail by ImprovMX (catch-all on planettransfers.online).
export const CONTACT_EMAIL = 'bookings@planettransfers.online';
export const WHATSAPP_NUMBER = '442045773877';
export const WHATSAPP_DISPLAY = '+44 20 4577 3877';
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
